import { t } from 'i18next';
import React, { useMemo, useState } from 'react';

import { IconName } from 'Components/foundation/icons';

import Battles from './Components/Battles/Battles';
import Campaigns from './Components/Campaigns/Campaigns';
import Courses from './Components/Courses/Courses';
import Menu from './Components/Menu/Menu';
import styles from './Dashboard.style';

export type MenuItemKey = 'global_stats' | 'courses' | 'campaigns' | 'battles' | 'wiki' | 'breaking_news';

export type MenuItem = {
  key: MenuItemKey;
  label: string;
  icon: IconName;
  disabled: boolean;
};

export const Dashboard: React.FC = () => {
  const [selectedItem, setSelectedItem] = useState<MenuItemKey>('campaigns');

  const items: MenuItem[] = useMemo(
    () => [
      { key: 'global_stats', label: t('analytics:dashboard.menu.global_stats'), icon: 'chart', disabled: true },
      { key: 'courses', label: t('analytics:dashboard.menu.courses'), icon: 'teacher', disabled: false },
      { key: 'campaigns', label: t('analytics:dashboard.menu.campaigns'), icon: 'trophy', disabled: false },
      { key: 'battles', label: t('analytics:dashboard.menu.battles'), icon: 'target-2', disabled: false },
      { key: 'wiki', label: t('analytics:dashboard.menu.wiki'), icon: 'book', disabled: true },
      { key: 'breaking_news', label: t('analytics:dashboard.menu.breaking_news'), icon: 'note', disabled: true },
    ],
    [t],
  );

  const handleItemClick = (key: MenuItemKey) => {
    setSelectedItem(key);
  };

  const ItemComponent = useMemo(() => {
    switch (selectedItem) {
      case 'campaigns':
        return Campaigns;
      case 'courses':
        return Courses;
      case 'battles':
        return Battles;
      default:
        return null;
    }
  }, [selectedItem]);

  return (
    <div style={styles.container}>
      <Menu items={items} selectedItem={selectedItem} onItemClick={handleItemClick} />
      {ItemComponent && <ItemComponent />}
    </div>
  );
};
